import React from 'react';
import PropTypes from 'prop-types';

import AbsoluteAsset from '../AbsoluteAsset';
import AbsoluteGear from '../AbsoluteGear';

import './engineering.scss';

const Engineering = props => (
  <div className="abs-asset-holder engineering">
    <div className="container">
      <div className="about__row2">
        <div className="eng-holder">
          <img src="/assets/eng.png" width="477" alt="Waterloo Engineering" />
          {props.children}
        </div>
      </div>
      <div className="about__row3">
        <div className="img-holder">
          <img src="/images/engineering.png" alt="People having fun at Hack the North" />
        </div>
      </div>
    </div>
    <AbsoluteGear className="gear--yellow2" src="/images/yellow2.png" />
    <AbsoluteGear className="gear--green1" speed={-10} src="/images/green1.png" />
    <AbsoluteGear className="gear--red2" src="/images/red2.png" />
    <AbsoluteGear className="gear--blue2" speed={-10} src="/images/blue2.png" />
    <AbsoluteAsset className="e52 e52--eng" src="/assets/e52.png" />
    <AbsoluteAsset className="e53 e53--eng" src="/assets/e53.png" />
  </div>
);

Engineering.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Engineering;



// WEBPACK FOOTER //
// ./src/components/Engineering/index.jsx